import { render, staticRenderFns } from "./IndexList.vue?vue&type=template&id=6ea2bbee&scoped=true&"
import script from "./IndexList.vue?vue&type=script&lang=js&"
export * from "./IndexList.vue?vue&type=script&lang=js&"
import style0 from "./IndexList.vue?vue&type=style&index=0&id=6ea2bbee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2bbee",
  null
  
)

export default component.exports